export class ListBackupJobTypesResponse {
    'backupJobTypes';
    'pagination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobTypes",
            "baseName": "backupJobTypes",
            "type": "Array<BackupJobType>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListBackupJobTypesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
